import { PUBLIC_API_VERSION } from "../../helpers/constants";

function mockRequests() {
  return !!globalThis.ENVS?.MOCK_REQUESTS;
}

export const MIN_LENGTH_OF_OTT = 8;
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const REQUEST_SUCCESS_BUT_SESSION_VALIDATION_FAILED =
  "REQUEST_SUCCESS_BUT_SESSION_VALIDATION_FAILED";
export const REQUEST_PENDING = "REQUEST_PENDING";
export const REQUEST_FAILED = "REQUEST_FAILED";

export const HTTP_503_SERVICE_NOT_AVAILABLE = 503;
export const HTTP_429_TOO_MANY_REQUESTS = 429;
export const HTTP_403_FORBIDDEN = 403;

export async function sendSignupRequest(email, adminEmail, ott) {
  if (mockRequests()) {
    if (ott.startsWith("fail")) {
      const error = new Error();
      error.status = HTTP_403_FORBIDDEN;
      throw error;
    }
    return delayResponseTestFunction(null, 1000);
  }

  return sendValidateOttRequest(email, adminEmail, ott);
}

export async function requestOtt(email, captchaResponse) {
  if (mockRequests()) {
    if (email.startsWith("fail")) {
      var error = new Error();
      error.status = HTTP_429_TOO_MANY_REQUESTS;
      throw error;
    } else if (email.startsWith("adminfoo")) {
      const domain = email.split("@")[1];
      return delayResponseTestFunction(
        {
          isRegistered: false,
          sentOtt: false,
          requiresAdminAuth: true,
          adminAddressList: [
            `postmaster@${domain}`,
            `admin@${domain}`,
            `foo@${domain}`,
          ],
        },
        1000
      );
    } else if (email.startsWith("postmaster")) {
      const domain = email.split("@")[1];
      return delayResponseTestFunction(
        {
          isRegistered: false,
          sentOtt: true,
          requiresAdminAuth: false,
          adminAddressList: [
            `postmaster@${domain}`,
            `admin@${domain}`,
            `foo@${domain}`,
          ],
        },
        1000
      );
    } else if (email.startsWith("error")) {
      throw new Error("Too many requests");
    }

    return delayResponseTestFunction(
      {
        isRegistered: true,
        sentOtt: true,
        requiresAdminAuth: true,
        adminAddressList: [email],
      },
      1000
    );
  }

  return sendOttRequest(email, captchaResponse);
}

export async function requestLogin(email, ott) {
  if (mockRequests()) {
    if (ott.startsWith("fail")) {
      return delayResponseTestFunction(false, 1000);
    }
    return delayResponseTestFunction(true, 1000);
  }

  return sendValidateOttRequest(email, undefined, ott)
    .then(() => true)
    .catch(() => false);
}

async function delayResponseTestFunction(x, ms) {
  await new Promise((resolve) => setTimeout(resolve, ms));
  return x;
}

async function sendOttRequest(email, captchaResponse) {
  const requestBody = {
    email: email,
    captchaResponse: captchaResponse,
  };

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": PUBLIC_API_VERSION,
      Accept: PUBLIC_API_VERSION,
    },
    body: JSON.stringify(requestBody),
  };

  return fetch(
    globalThis.ENVS.PUBLIC_API_BASE_URL + "/auth/validate-email",
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        const error = new Error();
        error.status = response.status;
        throw error;
      }

      return response.json();
    })
    .catch((e) => {
      if (e.status) {
        throw e;
      } else {
        const error = new Error();
        error.status = HTTP_503_SERVICE_NOT_AVAILABLE;
        throw error;
      }
    });
}

async function sendValidateOttRequest(email, adminEmail, ott) {
  const requestBody = {
    ott: ott,
    email: email,
    emailAdmin: adminEmail,
  };

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": PUBLIC_API_VERSION,
      Accept: PUBLIC_API_VERSION,
    },
    body: JSON.stringify(requestBody),
  };

  return fetch(
    globalThis.ENVS.PUBLIC_API_BASE_URL + "/auth/validate-ott",
    requestOptions
  )
    .then((response) => {
      console.log(response);
      if (!response.ok) {
        const error = new Error();
        error.status = response.status;
        throw error;
      }
      return true; // In this case there is no response body
    })
    .catch((e) => {
      if (e.status) {
        throw e;
      } else {
        const error = new Error();
        error.status = HTTP_503_SERVICE_NOT_AVAILABLE;
        throw error;
      }
    });
}

export async function fetchSessionEmailAddress(expectedMockReply) {
  if (mockRequests()) {
    return delayResponseTestFunction(expectedMockReply, 1000);
  }

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": PUBLIC_API_VERSION,
      Accept: PUBLIC_API_VERSION,
    },
  };

  return fetch(
    globalThis.ENVS.PUBLIC_API_BASE_URL + "/auth/validate-session",
    requestOptions
  )
    .then((response) => {
      if (response.ok) {
        const body = response.json();
        return body.then((e) => e.email);
      }

      return undefined;
    })
    .catch(() => {
      return undefined;
    });
}
